import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@src/store';
import { IFleetInitialState } from './types';

const FleetReducer = (state: RootState): IFleetInitialState => state.FleetPageReducer;
const FleetState = createSelector([FleetReducer], (state) => state);

export const selectDrone = createSelector([FleetState], (state) => state.selectedDrone);
